// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="footer" className="footer_style_2 footer_blog">
      <div className="container">
        {/* Full Width Logo Section */}
        

        <div className="row">

        <div className="row mb-5">
          <div className="col-12">
            <div className="footer-logo">
              <img 
                src="images/logos/logo-deepak.png" 
                className="img-fluid" 
                alt="Deepak Plywood & Timbers Logo" 
              />
              
            </div>
          </div>
        </div>

          {/* Column 1: Quick Links */}
          <div className="col-md-4">
            <div className="footer-section">
              <h2 className="footer-title">QUICK LINKS</h2>
              <ul className="footer-links">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/products">Product Range</Link></li>
                <li><Link to="/brands">Our Brand</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
              </ul>

              <div className="social-media-section">
                <h2 className="footer-title">Social Media Links</h2>
                <div className="social-icons">
                  <a href="https://wa.me/919314628326" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-whatsapp"></i>
                  </a>
                  <a href="https://www.instagram.com/deepakplywoodtimbersjaipur/" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-instagram"></i>
                  </a>
                  <a href="https://www.facebook.com/profile.php?id=61566204182461" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-facebook"></i>
                  </a>
                  <a href="https://x.com/deepakplywoods" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-twitter"></i>
                  </a>
                  <a href="https://www.youtube.com/@Deepakplywoodjaipur" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2: Get in Touch */}
          <div className="col-md-4">
            <div className="footer-section">
              <h2 className="footer-title">GET IN TOUCH</h2>
              <div className="contact-info">
                <p className="contact-item">
                  <strong>Mobile:</strong> +91-9314628326
                  <br />
                  <span className="indent">+91-9314628328</span>
                </p>
                <p className="contact-item">
                  <strong>Email:</strong> <a href="mailto:deepakplywood@yahoo.com">deepakplywood@yahoo.com</a>
                </p>
                <p className="contact-item">
                  <strong>Website:</strong> <a href="http://www.deepakplywood.com" target="_blank" rel="noopener noreferrer">www.deepakplywood.com</a>
                </p>
              </div>
            </div>
          </div>

          {/* Column 3: Map */}
          <div className="col-md-4">
            <div className="footer-section">
              <div className="map-container">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1778.4032428644693!2d75.74089845872194!3d26.944573400000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db317a970990f%3A0x11da12e86866a738!2sDeepak%20Plywood%20%26%20Timbers!5e0!3m2!1sen!2sin!4v1710835058953!5m2!1sen!2sin"
                  width="100%"
                  height="250"
                  style={{ border: '2px solid #DA251C', borderRadius: '4px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Deepak Plywood & Timbers Location"
                ></iframe>
              </div>
              <p className="address-text">
                <strong>Address:</strong> Near SBI Bank, Kanta Choraha, Ridhi Sidhi Nagar, Awadhpuri, Jhotwara, Kalwar Road, Jaipur, Rajasthan 302012
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="copyright">
                <p>© 2024 Deepak Plywood & Timbers. All rights reserved.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="developer-credit text-end">
                <p>Designed and Developed by <a href="https://www.seventricks.com/" target="_blank" rel="noopener noreferrer">Seventricks.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
